// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__4GzGv","spinner":"LoadingSpinner_spinner__Q1vlO"};